import request from '@/utils/httpRequest'

export default class putstoreService {
    getRuku(id) {
        return request({
            url: '/mater/ruku/' + id,
            method: 'get',
			class:'mater'
        })
    }
	viewEntityTemp(id) {
	  return request({
	    url: '/mater/rukutemp/viewTemp',
	    method: 'POST',
	    params: {
	      id: id
	    },
		class:'mater'
	  })
	}
}
